import { connect } from 'react-redux'
import {
    getGoogleAnalyticsConfiguration,
    isGoogleAnalyticsEnabled
} from '../../../redux/app/selectors'
import GoogleAnalytics from './GoogleAnalytics.jsx'

const mapStateToProps = state => ({
    configuration: getGoogleAnalyticsConfiguration(state),
    isEnabled: isGoogleAnalyticsEnabled(state),
})

export const GoogleAnalyticsContainer = connect(
    mapStateToProps,
)(GoogleAnalytics)
